import { TooltipComponent } from "@/components/ui/tooltip";

import { Avatar } from "@/components/Common/Avatar";

import { formatName } from "@/Utils/utils";
import { UserReadMinimal } from "@/types/user/user";

import { UserStatusIndicator } from "./UserListAndCard";

export default function UserBanner({
  userData,
}: {
  userData: UserReadMinimal;
}) {
  if (!userData) {
    return;
  }

  return (
    <div className="flex flex-col w-full justify-between gap-3 rounded transition-all duration-200 ease-in-out sm:flex-row">
      <div className="flex flex-row gap-2 self-center">
        <Avatar
          imageUrl={userData?.profile_picture_url}
          name={formatName(userData, true)}
          className="size-20 md:mr-2 shrink-0"
        />
        <div className="grid grid-cols-1 self-center">
          <div className="flex flex-row items-center gap-3">
            <TooltipComponent content={formatName(userData)} side="top">
              <h1 className="text-xl font-bold truncate" id="users-name">
                {formatName(userData)}
              </h1>
            </TooltipComponent>
            <div className="min-width-50 shrink-0 text-sm text-secondary-600">
              <UserStatusIndicator
                user={userData}
                addPadding
                className="pl-0"
              />
            </div>
          </div>
          <TooltipComponent content={userData.username} side="bottom">
            <p
              id="username"
              className="text-sm font-light leading-relaxed text-secondary-600 w-fit"
            >
              {userData.username}
            </p>
          </TooltipComponent>
        </div>
      </div>
      {/* AayushNet Logo */}
      <div className="hidden md:flex items-center gap-0 shrink-0">
        <img
          src="/images/aayushnet_logo_light.png"
          className="h-12"
          alt="AayushNet logo"
        />
        <h1
          className="text-2xl font-black tracking-wider"
          style={{
            fontFamily: "'Zen Kaku Gothic Antique', sans-serif",
          }}
        >
          <span
            style={{
              background:
                "linear-gradient(to bottom, #5ba3ff 0%, #002d6b 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              display: "inline-block",
              paddingBottom: "2px",
            }}
          >
            Aayush
          </span>
          <span
            style={{
              background:
                "linear-gradient(to bottom, #66ff99 0%, #1a7a3f 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
              display: "inline-block",
              paddingBottom: "2px",
            }}
          >
            Net
          </span>
        </h1>
      </div>
    </div>
  );
}
